export default __webpack_public_path__ + "static/media/tb-nft-default.ce305e70.svg";